import RichText from '@components/v2/ui/RichText/RichText';
import Typography from '@components/v2/ui/Typography/Typography';
import { Box } from '@mui/material';
import LangEnum from '../../../lang/LangEnum';
import { useTranslation } from '../../translation/TranslationContext';
import { hasVisibleText } from './utils/productDetailsContent.utils';

interface IProductDetailsDescription {
  resume?: string | null;
  description?: string | null;
}

const ProductDetailsDescription = ({ resume, description }: IProductDetailsDescription) => {
  const { translate } = useTranslation();

  const hasResume = hasVisibleText(resume);
  const hasDescription = hasVisibleText(description);

  if (!hasResume && !hasDescription) {
    return (
      <Typography variant="body1" color="text.secondary">
        {translate(LangEnum.GLOBAL_NO_INFORMATIONS)}
      </Typography>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
      }}
    >
      {hasDescription && <RichText colorToken="text.secondary">{description}</RichText>}

      {hasResume && <RichText colorToken="text.secondary">{resume}</RichText>}
    </Box>
  );
};

export default ProductDetailsDescription;
